module.exports = __webpack_public_path__ + "img/2.1c8ae91b.png";